<template>
  <div id="app" class="w-auto">
    <Navbar />
    <!-- <Sidebar/> -->
    <!-- <DriverForm/>
    <DriverList :drivers="drivers"/>
    <PassengerForm/> -->
    <!-- <TripList :trips="trips"/> -->
    <!-- <TripDetail :tripLines="tripLines"/> -->
  </div>
</template>

<script>
// import DriverForm from '@/components/driver/DriverForm.vue'
// import DriverList from '@/components/driver/DriverList.vue'
// import PassengerForm from '@/components/passenger/PassengerForm.vue'
// import TripList from '@/components/trip/TripList.vue'
// import TripDetail from '@/components/trip/TripDetail.vue'
// import Sidebar from '@/components/layout/Sidebar.vue'
import Navbar from "@/components/layout/Navbar.vue";

export default {
  name: "App",
  components: {
    Navbar,
  },
};
</script>

<style></style>
